import { create } from 'zustand'
import { initialStore } from './InitialValues'

const useStore = create(set => ({
  dataResults: [],
  queryStore: '',
  firstRender: true,
  page: 1,
  isQueryLoading: false,
  //
  name: '',
  brand: '',
  brandManufacturer: '',
  GTIN: '',
  SKUS: '',
  taxonomyLevel1: '',
  taxonomyLevel2: '',
  taxonomyLevel3: '',
  primaryCategories: ['Any'],
  rawCategory: '',
  categoryWildCard: '',
  categoriesWithParenthesis: '',
  rentalPrice: {
    minValue: '',
    maxValue: '',
    currency: ''
  },
  mostRecentPriceDate: {
    startDate: '',
    endDate: ''
  },
  description: {
    value: ''
  },
  reviewsRangeQuery: {
    // New field for reviews range
    min: '',
    max: ''
  },
  recordRecency: {
    dateAdded: '',
    dateUpdated: ''
  },
  featureKeyword: {
    key: '',
    value: ''
  },
  requiredFields: [],
  domain: '',
  mostRecentPriceIsSale: '',
  taxonomy: '',
  price: {
    minValue: '',
    maxValue: '',
    currency: ''
  },
  priceWarranty: '',
  color: '',
  featuresWithKey: '',
  manufacturerNumber: '',
  shouldRefetch: false,

  // Setters
  setName: setName => set(() => ({ name: setName })),
  setBrand: setBrand => set(() => ({ brand: setBrand })),
  setDomain: setDomain => set(() => ({ domain: setDomain })),
  setBrandManufacturer: setBrandManufacturer =>
    set(() => ({ brandManufacturer: setBrandManufacturer })),
  setGTIN: setGTIN => set(() => ({ GTIN: setGTIN })),
  setSKUS: setSKUS => set(() => ({ SKUS: setSKUS })),
  setTaxonomyLevel1: setTaxonomyLevel1 =>
    set(() => ({ taxonomyLevel1: setTaxonomyLevel1 })),
  setTaxonomyLevel2: setTaxonomyLevel2 =>
    set(() => ({ taxonomyLevel2: setTaxonomyLevel2 })),
  setTaxonomyLevel3: setTaxonomyLevel3 =>
    set(() => ({ taxonomyLevel3: setTaxonomyLevel3 })),
  setFirstRender: value => set(() => ({ firstRender: value })),
  setPage: newPage => set(() => ({ page: newPage })),
  setPrimaryCategories: newCategories =>
    set(() => ({ primaryCategories: newCategories })),
  setRawCategory: newRawCategory =>
    set(() => ({ rawCategory: newRawCategory })),
  setCategoryWildCard: newCategoryWildCard =>
    set(() => ({ categoryWildCard: newCategoryWildCard })),
  setCategoriesWithParenthesis: newCategories =>
    set(() => ({ categoriesWithParenthesis: newCategories })),
  setIsQueryLoading: loading => set(() => ({ isQueryLoading: loading })),
  setQueryStore: newQuery => set(() => ({ queryStore: newQuery })),
  setDataResults: newData => set(() => ({ dataResults: newData })),
  setRentalPrice: newRentalPrice =>
    set(state => ({
      rentalPrice: { ...state.rentalPrice, ...newRentalPrice }
    })),
  setMostRecentPriceDate: newDateRange =>
    set(state => ({
      mostRecentPriceDate: {
        ...state.mostRecentPriceDate,
        ...newDateRange
      }
    })),
  setDescription: updates =>
    set(state => ({
      description: {
        ...state.description,
        ...updates
      }
    })),
  setRecordRecency: updates =>
    set(state => ({
      recordRecency: {
        ...state.recordRecency,
        ...updates
      }
    })),
  setFeatureKeyword: updates =>
    set(state => ({
      featureKeyword: {
        ...state.featureKeyword,
        ...updates
      }
    })),
  setRequiredFields: newRequiredFields =>
    set(() => ({ requiredFields: newRequiredFields })),
  setReviewsRangeQuery: ({ min, max }) =>
    set(() => ({
      reviewsRangeQuery: { min, max }
    })),
  setMostRecentPriceIsSale: setMostRecentPriceIsSale =>
    set(() => ({ mostRecentPriceIsSale: setMostRecentPriceIsSale })),
  setTaxonomy: setTaxonomy => set(() => ({ taxonomy: setTaxonomy })),

  // New setter for price
  setPrice: newPrice =>
    set(state => ({
      price: {
        ...state.price,
        ...newPrice
      }
    })),

  setPriceWarranty: value =>
    set(() => ({
      priceWarranty: value
    })),

  setColor: setColor => set(() => ({ color: setColor })),
  setFeaturesWithKey: setFeature => set(() => ({ featuresWithKey: setFeature })),

  setManufacturerNumber: setManufacturerNumber => set(() => ({ manufacturerNumber: setManufacturerNumber })),
  setShouldRefetch: (value) => set(() => ({ shouldRefetch: value })),

  resetStore: () => set(() => ({ ...initialStore, firstRender: true }))
}))

export default useStore
